import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../context/useAuth';
import { Center, Spinner } from '@chakra-ui/react';
import { STUDENT } from '../constants';

const AuthRedirectGuard = () => {
  const { isAuthenticated, loading, role } = useAuth();

  if (loading) {
    return (
      <Center height="100vh">
        <Spinner size="xl" color="#fca43b" />
      </Center>
    );
  }

  // If user is authenticated, redirect
  if (isAuthenticated) {
    if (role === STUDENT) {
      return <Navigate to="/top" replace />;
    }
    return <Navigate to="/students" replace />;
  }

  // If not authenticated, redirect login page
  return <Outlet />;
};

export default AuthRedirectGuard;
